import { render, staticRenderFns } from "./ModalDetailEmployee.vue?vue&type=template&id=071d8730&"
import script from "./ModalDetailEmployee.vue?vue&type=script&lang=js&"
export * from "./ModalDetailEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailEmployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports